<ng-select
  [items]="options"
  bindLabel="label"
  [placeholder]="selected ? '' : placeholder"
  [ngModel]="selected"
  (change)="onChange($event)"
  [searchable]="false"
  [markFirst]="false"
  [clearable]="false"
  class="cliente-select"
  [class.cliente-select--compact]="compact">
</ng-select>
